'use strict';

import Toast from 'bootstrap/js/src/toast';

class VZCopyToClipboard extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.addEventListener('click', this.copyToClipboard);
    }

    disconnectedCallback() {
        this.removeEventListener('click', this.copyToClipboard);
    }

    createHiddenField() {
        return new Promise((resolve) => {
            const input = document.createElement('input');
            input.setAttribute('readonly', 'readonly');
            input.value = this.getAttribute('text') || this.innerText;
            this.insertAdjacentElement('beforeend', input);
            resolve(input);
        });
    }

    copyToClipboard() {
        this.createHiddenField().then(this.constructor.copy).then(this.constructor.removeHiddenField).then(this.giveFeedback.bind(this));
    }

    static copy(input) {
        return new Promise((resolve) => {
            input.select();
            document.execCommand('copy');
            resolve(input);
        });
    }

    giveFeedback() {
        const uniqueID = new Date().getTime();
        document.body.insertAdjacentHTML(
            'beforeend',
            `<div id="${uniqueID}" class="toast align-items-center position-fixed" role="alert" aria-live="assertive" aria-atomic="true" style="z-index:99; bottom: 30px; right: 30px;">
            <div class="d-flex">
                <div class="toast-body">${this.getAttribute('copied')}</div>
            </div>
        </div>`
        );

        const toast = new Toast(document.getElementById(uniqueID));
        toast.show();
        setTimeout(() => {
            toast.dispose();
        }, 2500);
    }

    static removeHiddenField(input) {
        return new Promise((resolve) => {
            input.remove();
            resolve();
        });
    }
}

export default window.customElements.get('vz-copy-to-clipboard') || VZCopyToClipboard;
if (!window.customElements.get('vz-copy-to-clipboard')) {
    window.customElements.define('vz-copy-to-clipboard', VZCopyToClipboard);
}
